import React from 'react';
import _ from 'lodash';
import classnames from 'classnames/bind';
import style from './index.module.scss';
import publicImage from '../../../utils/publicImage';
import {IComponentVolumes, IProd, IState, Replacement} from '../../../interface';
import {connect, useSelector} from 'react-redux';
import localesReplacement from '../../../utils/localesReplacement';
import { useAppName } from '../../../hooks/use-app-names';
import { FASTSCAN } from '../../../constants';

const cx = classnames.bind(style);

interface IProps {
  dataList?: IProd;
  withoutMoreLink: boolean;
  componentVolumes?: IComponentVolumes[];
  replacements: Replacement;
  moreLinkClick?: () => void;
  notes?: string[]
}

export const OilVolumesService = (props: IProps) => {
  const {
    withoutMoreLink,
    dataList,
    componentVolumes,
    replacements,
    moreLinkClick,
    notes
  } = props;
  const countryCode = useSelector((state: any) => state.country.isoCode);
  const isFastScan = useAppName(FASTSCAN);
  const redirect = () => {
    moreLinkClick && moreLinkClick();
  };
  return (
    <div className={`vs-block ${cx('block')}`}>
      {componentVolumes && (
        <>
          <div className={`column ${cx('column')}`}>
            <strong>
              {localesReplacement(replacements, 'Vehicle Component Volumes')}
            </strong>
            {_.isEmpty(componentVolumes) ||
            !_.find(componentVolumes, (item) => !_.isEmpty(item)) ? (
              <span className={cx('empty')}>
                {localesReplacement(replacements, 'N/A')}
              </span>
            ) : (
              <dl>
                {componentVolumes &&
                  componentVolumes[0] &&
                  componentVolumes[0]['name'] &&
                  _.map(
                    componentVolumes,
                    (d, i) =>
                      d && (
                        <div key={i}>
                          <dt>{d && localesReplacement(replacements, d['name'])}</dt>
                          <dd>
                            {d && d['condition']} {d && d['value']}{' '}
                            {localesReplacement(
                              replacements,
                              (d && d['unit']),
                            )}
                          </dd>
                        </div>
                      ),
                  )}
                {componentVolumes &&
                  componentVolumes[0] &&
                  !componentVolumes[0]['name'] && (
                    <div>
                      {componentVolumes.map((val, idx) => (
                        <div key={idx}>{val}</div>
                      ))}
                    </div>
                  )}
              </dl>
            )}
          </div>
        </>
      )}
      {(countryCode !== 'AUS' && countryCode !== 'NZL' && dataList?.serviceIntervals && dataList?.serviceIntervals.length > 0) && (
        <div className={`column ${cx('column')}`}>
          <strong>
            {localesReplacement(replacements, 'Service Intervals')}
          </strong>
          {dataList && _.isEmpty(dataList['serviceIntervals']) ? (
            <span className={cx('empty')}>
              {localesReplacement(replacements, 'N/A')}
            </span>
          ) : (
            <table>
              <tbody>
                {dataList && _.map(dataList['serviceIntervals'], (d, i) => (
                  <tr key={i}>
                    <td><p title={d['name']}><span>{d['name']}</span> :</p></td>
                    <td><p title={d['description']}><span>{d['description']}</span></p></td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}
      {notes && Array.isArray(notes) && notes.length > 0 && (
        <div className={`column ${cx('column')}`}>
          <strong> {localesReplacement(replacements, 'Notes')}</strong>
          <dl>
            { notes.map((note, i) => {return (<dd key={i}> {note} </dd>)})}
        </dl>
        </div>
      )}
      {!withoutMoreLink && !isFastScan && (
        <div
          className={cx('column', 'more-info', {
            last: !componentVolumes,
          })}
        >
          <div className={cx('thumb')}>
            <img src={publicImage('user.jpg')} />
          </div>
          <div className={cx('link-box')}>
            <span>
              {localesReplacement(replacements, 'Are you a mechanic')}?
            </span>
            <span role='link' className='primary-link' onClick={redirect}>
              {localesReplacement(
                replacements,
                'Click here for more information',
              )}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state: IState) => ({
  replacements: state.replacements,
});

export default connect(mapStateToProps)(OilVolumesService);
